import { IBusinessType } from '@/models/business';
import { ILocation } from '@/models/location';

export class RootStateBusiness {
  constructor(
    public business?: Business,
    public businessDetailForm?: Business,
    public version?: string,
    public alerts?: alert[],
    public widgetWarnChanges?: any,
    public rewardStatus?: any,
    public subscription?: any
  ) {}
}

export interface IRewardStatus {
  rewardStatus: string;
  updatedAt: Date;
  operationType: string;
  operationStatus: string;
  providers: any[];
}

export enum EBillingStatusTypes {
  UNAVAILABLE = 'unavailable',
  PENDING = 'pending',
  SUBSCRIBED = 'active',
  UNSUBSCRIBED = 'inactive',
  TO_BE_CANCELED = 'to-be-canceled',
  DELAY_PERIOD = 'delay-period'
}

export enum EBusinessUserType {
  MANAGER = 'manager',
  OWNER = 'owner'
}
export interface alert {
  type: string;
  active: boolean;
  id?: string;
}

export class Business {
  constructor(
    public id?: string,
    public createdAt?: string,
    public updatedAt?: string,
    public name?: string,
    public address?: string,
    public addressAdditional?: string,
    public type?: IBusinessType,
    public city?: string,
    public state?: string,
    public zip?: string,
    public country?: string,
    public countryIso2?: string,
    public phone?: string,
    public phoneCountryCode?: string,
    public phoneCountryIso?: string,
    public website?: string,
    public manager?: Manager,
    public coinExchangeRatio?: string,
    public coinPurchaseRatio?: string,
    public coinRewardPercentage?: string,
    public coinPurchaseBonus?: string,
    public coinGiveFirst?: string,
    public coinGiveFirstAmount?: number,
    public coinGiveFirstPotLimit?: number,
    public coinGiveFirstDistributed?: number,
    public lat?: string,
    public lng?: string,
    public status?: string,
    public logo?: Logo,
    public businessLocations?: ILocation[],
    public teamMembers?: Member[],
    public hadRefund?: boolean
  ) {}
}

interface Manager {
  fullname: string;
  id: string;
  role: 'owner' | 'manager';
}

export interface Member {
  id: string;
  fullname: string;
  status: string;
  mail: string;
  businessId: string;
  managerId: string;
  inviteId: string;
  role?: string;
}

export interface Logo {
  logo: {
    id: string;
    createdAt: string;
    updatedAt: string;
    filename: string;
    mimetype: string;
    path: string;
    publicPath: {
      small: string;
      large: string;
    };
    size: string;
    context: string;
    status: string;
  };
}
